import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { LazyPreviouslyOrderedModal } from "@faire/deprecated-retailer-visitor-shared/views/product/ProductDetails/__internal__/Header/PreviouslyOrderedBanner/LazyPreviouslyOrderedModal";
import { Core } from "@faire/design-tokens";
import { getColor } from "@faire/sdui/lib/getColor";
import { getIcon } from "@faire/sdui/lib/getIcon";
import { useQuery } from "@faire/web-api--source/endpoints/www/api/product-reorder-data/productToken/get-hooks";
import { trackProductPageViewReorderBannerActionCategoryImpression } from "@faire/web-api--source/events/productPage/actionCategoryImpression/viewReorderBanner";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { Button } from "@faire/web/slate-deprecated/Button";
import { ChevronRight } from "@faire/web/slate/icons/Chevron";
import { Row, Flex } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import React, { useState, Suspense } from "react";

export const PreviouslyOrderedBanner: React.FC<{
  reorderInfo?: IProductPageResponse.IPdpProduct.IReorderInformation;
  productToken?: string;
}> = ({ reorderInfo, productToken }) => {
  useTraceComponentRender("PreviouslyOrderedBanner");
  const [isOpen, setIsOpen] = useState(false);
  const { data, error } = useQuery(productToken ?? "", {
    enabled: !!productToken && !!reorderInfo,
  });
  const retailerToken = getRetailer()?.token;

  const handleClick = () => {
    if (enable_cta) {
      setIsOpen(true);
    }
  };
  const onView = () => {
    trackProductPageViewReorderBannerActionCategoryImpression(
      productToken ?? "",
      retailerToken ?? "",
      reorderInfo?.message ?? ""
    );
  };
  const viewRef = useDoActionWhenVisible(onView);

  if (!reorderInfo) {
    return null;
  }
  const { icon, message, enable_cta } = reorderInfo;
  const Icon = getIcon(icon);

  return (
    <>
      <Row ref={viewRef} align="center" gap={8}>
        <Flex
          align="center"
          justify="center"
          className="h-8 min-w-8 rounded"
          style={{
            backgroundColor: getColor(icon?.background_color_token),
          }}
        >
          <Icon color={getColor(icon?.color_token)} />
        </Flex>
        <Button
          variant="tertiary"
          className="flex items-center gap-2 !no-underline"
          disabled={!enable_cta}
          onClick={handleClick}
        >
          <Typography
            variant="paragraphSansMedium"
            style={{ color: enable_cta ? "inherit" : Core.text.default }}
          >
            {message}
          </Typography>
          {enable_cta ? (
            <ChevronRight
              data-test-id="chevron-button"
              height="12px"
              width="12px"
            />
          ) : null}
        </Button>
        {enable_cta ? (
          <Suspense fallback={null}>
            <LazyPreviouslyOrderedModal
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              data={data}
              error={error}
            />
          </Suspense>
        ) : null}
      </Row>
      <Spacer height="3x" />
    </>
  );
};
